<template>
    <div class="page products-page px-md-8">
        <v-container class="py-3 py-lg-8 px-0">
            <transition name="fade-transition">
                <div v-if="productsMeta">
                    <crud-table :actions="actions" show-search search-placeholder="ابحث في المنتجات" server-pagination :page-count="productsMeta.last_page" :current-page="productsMeta.current_page" :total="productsMeta.total" :per-page="productsMeta.per_page" create-button-text="إضافة منتج" title="المنتجات" :items="productsItems" :headers="headers" @open="openProduct" @load="loadMore" @search="searchHandler" @reset="reset" @create="createDialog = true" @delete="openDeleteDialog" @edit="openEditDialog" />
                </div>
            </transition>


            <action-dialog v-model="createDialog" :status422Msg="true" :as-form-data="true" scrollable max-width="420" vuex-action="createProduct" success-msg="تم إضافة المنتج بنجاح" title="إضافة منتج جديد" subtitle="أدخل بيانات المنتج ليتم إضافته إلى متجرك" button-text="إضافة" :data="newProduct" @reset="resetCreateForm">
                <div class="pt-1">
                    <v-text-field v-model="newProduct.name" autofocus label="اسم المنتج *" placeholder="أدخل اسم المنتج" hide-details class="mb-5"></v-text-field>
                    <v-select v-model="newProduct.categories" multiple label="اﻷقسام *" placeholder="اختر اﻷقسام" hide-details :items="categoriesListItems" class="mb-5">
                        <template v-slot:selection="{item}">
                            <v-chip color="surface2" label small :key="item.value">
                                <v-icon size="14" class="me-1" left>mdi-view-grid-outline</v-icon>
                                {{item.text}}
                            </v-chip>
                        </template>
                    </v-select>
                    <v-text-field v-model="newProduct.price" type="number" label="سعر المنتج *" placeholder="أدخل سعر المنتج" min="0" hide-details suffix="" class="mb-5"></v-text-field>
                    <!-- <v-text-field v-model="newProduct.wholesale_price" type="number" label="سعر الجملة" placeholder="أدخل سعر المنتج" min="0" hide-details suffix="" class="mb-5"></v-text-field> -->
                    <v-select v-model="newProduct.hidden" label="ظهور المنتج" :items="[{text:'الظهور مفعل', value: false}, {text: 'مخفي من المتجر', value: true}]" placeholder="اختر ظهور المنتج" hide-details class="mb-5"></v-select>
                    
                    <v-file-input v-model="newProduct.image" ref="imageInput" accept="image/png, image/jpeg, image/gif" placeholder="اختر صورة" prepend-icon="" prepend-inner-icon="mdi-image" label="الصورة المصغرة (اختياري)" ></v-file-input>

                    <v-checkbox v-model="newProduct.track_stock" label="تفعيل إدارة المخزون" color="primary" class="mb-3" hide-details></v-checkbox>
                    <template v-if="newProduct.track_stock">
                        <v-text-field v-model="newProduct.stock" type="number" label="الكمية المتوفرة" placeholder="أدخل الكمية المتوفرة من مخزون المنتج" min="0" hide-details suffix="" class="mb-5"></v-text-field>
                    </template>

                    <v-checkbox v-model="newProduct.featured" label="تحديد كمنتج مميز" color="orange darken-1" class="mb-3" hide-details></v-checkbox>
                </div>
            </action-dialog>


            <action-dialog v-model="editDialog" scrollable max-width="420" vuex-action="editProduct" success-msg="تم حفظ التغييرات بنجاح" title="تعديل المنتج" subtitle="سيتم تنفيذ التغييرات لحظياً" button-text="تعديل" :data="{id: editedItem.id, data: editedItem}" @reset="resetEditForm">
                <div class="pt-1">
                    <v-text-field v-model="editedItem.name" label="اسم المنتج" placeholder="أدخل اسم المنتج" hide-details class="mb-5"></v-text-field>
                    <v-select v-model="editedItem.categories" multiple label="اﻷقسام" placeholder="اختر اﻷقسام" hide-details :items="categoriesListItems" class="mb-5">
                        <template v-slot:selection="{item}">
                            <v-chip color="surface2" label small :key="item.value">
                                <v-icon size="14" class="me-1" left>mdi-view-grid-outline</v-icon>
                                {{item.text}}
                            </v-chip>
                        </template>
                    </v-select>
                    <v-select v-model="editedItem.hidden" label="ظهور المنتج" :items="[{text:'الظهور مفعل', value: false}, {text: 'مخفي من المتجر', value: true}]" placeholder="اختر ظهور المنتج" hide-details class="mb-5"></v-select>

                    <v-checkbox v-model="editedItem.track_stock" label="تفعيل إدارة المخزون" color="primary" class="mb-3" hide-details></v-checkbox>
                    <v-checkbox v-model="editedItem.featured" label="تحديد كمنتج مميز" color="orange darken-1" class="mb-3" hide-details></v-checkbox>
                </div>
            </action-dialog>

            <action-dialog v-model="deleteDialog" vuex-action="deleteProduct" :title="`حذف المنتج #${deleteItem ? deleteItem.id : ''}`" :data="{id: deleteItem ? deleteItem.id : null}" button-text="تأكيد الحذف" button-color="error">
                هل أنت متأكد من حذف المنتج <span class="strong-text--text">"{{deleteItem ? deleteItem.name : ''}}"</span> ؟
            </action-dialog>
        </v-container>
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import CrudTable from '@/components/default/crud-table'

export default {
    name: "Products",
    components: {
        CrudTable
    },
    data(){
        return {
            loading: false,   
            createDialog: false,
            newProduct: {
                name: '',
                categories: [],
                // wholesale_price: '',
                price: '',
                image: null,
                track_stock: false,
                stock: '',
                hidden: false,
                featured: false,
            },
            editDialog: false,
            editedItem: {
                id: '',
                name: '',
                categories: [],
                track_stock: false,
                hidden: false,
                featured: false,
            },

            deleteDialog: false,
            deleteItem: null,

            headers: [
                {
                    text: 'معرف',
                    align: 'start',
                    sortable: false,
                    value: 'item_id',
                },
                {
                    text: 'بيانات المنتج',
                    align: 'start',
                    sortable: false,
                    value: 'main_image_url',
                    avatarText: 'name',
                    avatar: true,
                    width: 40,
                    height: 40,
                    bordered: true,
                    tile: true,
                    href: 'productTo',
                    color: 'primary',
                },
                {
                    text: 'السعر',
                    value: 'priceComputed',
                    align: 'center',
                    sortable: false,
                },
                {
                    text: 'المخزون',
                    value: 'stockComputed',
                    align: 'center',
                    sortable: false,
                },
                {
                    text: 'حالة الظهور',
                    align: 'center',
                    sortable: false,
                    value: 'hidden',

                    chip: true,
                    chipFunction: (hidden)=>{
                        if (hidden){
                            return {text: 'مخفي', color: 'muted', icon: 'mdi-eye-off'}
                        }else{
                            return {text: 'ظاهر', color: 'primary', icon: 'mdi-eye'}
                        }
                    },
                },
                {
                    text: 'وقت اﻹنشاء',
                    value: 'created_at',
                    time: true,
                    align: 'center',
                    sortable: false,
                },
            ],
        }
    },
    computed: {
        ...GlobalComputed,
        products(){
            return this.$store.state.productsModule.products;
        },
        categories(){
            return this.$store.state.productsModule.productsCategories;
        },
        categoriesListItems(){
            return this.categories ? this.categories.map(category=>{
                return {
                    value: category.id,
                    text: category.name
                }
            }) : [];
        },
        productsMeta(){
            return this.$store.state.productsModule.productsMeta;
        },
        productsItems(){
            return this.products ? this.products.map(product=>{
                let prices = [];
                let stocks = [];
                product.variants.forEach(variant=>{
                    const price = variant.discount ? variant.price - variant.discount : variant.price;
                    prices.push(this.moneyFormat(price));
                    if (variant.stock){
                        stocks.push(this.numFormat(variant.stock));
                    }
                });
                let priceComputed = prices.length > 1 ? `${prices[0]} - ${prices[prices.length-1]}` : prices[0];
                let stockComputed = product.track_stock ? stocks.slice(0, 4).join('+') : 'غير متتبع';
                return {
                    ...product,
                    item_id: product.local_serial,
                    productTo: {name: 'product', params: {id: product.id}},
                    priceComputed,
                    stockComputed,
                };
            }) : [];
        },
        actions(){
            return [
                {name: 'open', text: 'عرض المنتج', icon: 'mdi-open-in-new', color: 'primary'},
                {name: 'edit', text: 'تعديل', icon: 'mdi-square-edit-outline', color: 'text'},
                {name: 'delete', text: 'حذف', icon: 'mdi-delete', color: 'red darken-1', show: 'deletable'}
            ]
        },
        searchQuery(){
            return this.$route.query.search;
        }
    },
    watch: {
        loading(loading){
            this.setLinearLoading(loading);
        },
        searchQuery(query){
            this.loadData();
        }
    },
    methods: {
        ...GlobalMethods,
        loadData(page=1){
            if (!this.loading){
                this.loading = true;
                const query = this.searchQuery || null;
                this.$store.dispatch('getProducts', {page, query}).then(response=>{
                    this.loading = false;
                }).catch(e=>{
                    this.loading = false;
                    this.showMsg('حدثت مشكلة أثناء تحميل المنتجات', 'error');
                })
            }
        },
        loadMore(payload){
            this.loadData(payload.page);
        },
        reset(){
            if (this.searchQuery){
                this.$router.replace({query: {}})
            }
            this.loadData();
        },
        searchHandler(search){
            this.$router.replace({query: {search}})
        },
        openProduct(product){
            this.$router.push({name: 'product', params: {id: product.id}});
        },
        resetCreateForm(){
            this.newProduct = {
                name: '',
                categories: [],
                // wholesale_price: '',
                price: '',
                image: null,
                track_stock: false,
                stock: '',
                hidden: false,
                featured: false,
            };
        },
        openEditDialog(item){
            for(let key in this.editedItem){
                if (key === 'categories'){
                    this.editedItem.categories = item.categories.map(c=>c.id);
                }else{
                    this.editedItem[key] = item[key];
                }
            }
            // Object.assign(this.editedItem, item);
            this.editDialog = true;
        },
        resetEditForm(){
            this.editedItem = {
                id: '',
                name: '',
                categories: [],
                track_stock: false,
                hidden: false,
                featured: false,
            };
        },
        openDeleteDialog(item){
            this.deleteDialog = true;
            this.deleteItem = item;
        },
    },
    mounted(){
        this.loadData();
    }
};
</script>
